import { Api } from "./Api";
//import Cookie from "js-cookie";

export default {
  getCookie() {
    // let token = Cookie.get("XSRF-TOKEN");
    // console.log("🚀 ~ getCookie ~ token:", token, !!token, token === null, token == null, token === undefined);

    // if (token) {
    //   return new Promise(resolve => {
    //     resolve(token);
    //   });
    // }

    return Api.get("/csrf-cookie");
  },
};
